export const useI18nForEva = () => {
  const { setLocale } = useI18n();

  watchEffect(() => {
    const isFormal = useContextStore().isFormal;
    const locale = isFormal ? 'fr_formal' : 'fr';
    setLocale(locale);
  });
};
